import React, { useState, forwardRef, useEffect } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import Upload from "../../../Assets/Image/png/upload.png";
import { BtnPrimary } from "../buttons/Btn";
import Uploaded from "../input/Upload/Uploaded";
const DragAndDrop = forwardRef((props, ref) => {
    const {
        value,
        isSubmitted,
        message,
        defValue,
        error,
        label,
        id,
        icon,
        type,
        close,
        bootcamp_cover,
        ...rest
    } = props;
    const [createObjectURL, setCreateObjectURL] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [uploaded, setUploaded] = useState(false);
    const handleChange = ({ target }) => {
        if (target.files) {
            props.setFile(target.files);
            console.log("first", target?.files);
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                setCreateObjectURL(reader.result);
            });
            reader.readAsDataURL(target.files[0]);
            setFileName(target?.files[0]?.name);
        }
    };
    useEffect(() => {
        if (isSubmitted) {
            setFileName("");
        }
    }, [isSubmitted]);

    useEffect(() => {
        if (props.sessionInfo === false) {
            setFileName("");
            setCreateObjectURL("");
        }
    }, [props.sessionInfo]);
    //TODO : inja momkene baghie jaha bug beshe

    const onClickUploadHandler = () => {
        if (props.uploadFile) {
            console.log("true upload handler");
            if (props.sessions) {
                console.log("session file upload");
            }
        } else if (!props.uploadFile) {
            console.log("false upload handler");
        }
        props.close(true);
    };

    return (
        <div className="text-center">
            {uploaded ? (
                <Uploaded close={setUploaded} show={uploaded} />
            ) : (
                <>
                    <h3 className="text-[#77498F] font-bold text-[20px] text-center mb-14">
                        آپلود فایل
                    </h3>
                    <div className=" text-right text-[#212121E5] text-[1.8rem] font-normal leading-[3.2rem]">
                        {fileName}
                    </div>
                    <div
                        onDrag={handleChange}
                        className="border-purple border-dashed border-[1px] rounded-3xl  text-center text-[1.8rem] flex justify-center flex-col items-center cursor-pointer relative"
                    >
                        <input
                            ref={ref}
                            type="file"
                            onInput={handleChange}
                            className="cursor-pointer w-full h-full absolute opacity-0"
                            {...rest}
                            id={id}
                        />
                        <div className=" py-24 px-[21rem] text-center flex justify-center flex-col items-center cursor-pointer">
                            {type === "image" && (createObjectURL|| bootcamp_cover) ? (
                                <img
                                    className=" max-w-[30.7rem] max-h-[20.5rem]"
                                    src={createObjectURL || bootcamp_cover}
                                    alt="Card  cap"
                                />
                            ) : (
                                <>
                                    {" "}
                                    <img
                                        src={Upload}
                                        className=" mb-14"
                                        alt="Upload"
                                    />
                                    <p>
                                        فایل مورد نظر خود را بکشید و اینجا رها
                                        کنید.
                                    </p>
                                    <p>
                                        یا در کامپیوتر خود{" "}
                                        <span className=" text-[#9C5FA4]">
                                            {" "}
                                            جستجو
                                        </span>{" "}
                                        کنید
                                    </p>
                                </>
                            )}
                            <Cancel
                                onClick={() => close(false)}
                                className=" cursor-pointer absolute right-5 top-6"
                            />
                        </div>
                    </div>
                    <BtnPrimary
                        text="آپلود فایل"
                        className=" py-7 px-32 mt-12"
                        onClick={onClickUploadHandler}
                    />
                    {error && <span className="input__message">{message}</span>}{" "}
                </>
            )}
        </div>
    );
});

export default DragAndDrop;
